import { render } from "./InvoiceStatus.vue?vue&type=template&id=55665978"
import script from "./InvoiceStatus.vue?vue&type=script&lang=js"
export * from "./InvoiceStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__